var a = ":host{--ngc-avatar-background-color: var(--color-surface-brand-secondary, #F0F0F0);--ngc-avatar-color: var(--color-text-brand, #11395B)}";
export { a as default };